interface IconProps {
	className?: string
}

export const QuoteIcon: React.FC<IconProps> = ({ className }) => {
	return (
		<svg className={className} viewBox="0 0 20 15" fill="black" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.2 0.730225H14L11.2 6.33022V14.7302H19.6V6.33022H15.4L18.2 0.730225ZM7 0.730225H2.8L0 6.33022V14.7302H8.4V6.33022H4.2L7 0.730225Z"
				fill="white"
			/>
		</svg>
	)
}
